import { gql } from "@apollo/client";

export const REMOVE_USER = gql`
  mutation removeUserByEmail($email: String!) {
    removeUserByEmail(
      email: $email,
    ) {
      deleted,
      messages,
    }
  }`;
